import { useRouter } from 'next/router';
import { useEffect } from 'react';

//according to nextJS doc => https://nextjs.org/docs/14/pages/api-reference/functions/use-router#routerevents

type UseNavigationEventListenerProps = {
  cb: (params?: { url?: string; shallow?: any }) => void;
};

export const useNavigationEventListener = ({
  cb,
}: UseNavigationEventListenerProps) => {
  const router = useRouter();

  useEffect(() => {
    const handleRouteChange = (url: string, { shallow }) => {
      cb({ url, shallow });
    };

    router.events.on('routeChangeStart', handleRouteChange);

    // If the component is unmounted, unsubscribe
    // from the event with the `off` method:
    return () => {
      router.events.off('routeChangeStart', handleRouteChange);
    };
  }, [router]);
};
